import React, {useContext} from 'react'
import {AuditPaneContext} from '../../../context/AuditPane'
import {AuditDetailsContext} from '../../../context/Modal/AuditDetails'
import {AuditModalApiContext} from '../../../context/AuditModalApi'
import {AuditModalBarContext} from '../../../context/AuditModalBar'
import {useTranslation} from 'react-i18next'
import {AuditContext} from '../../../context/Audits'
import {TemplatesContext} from '../../../context/Templates'
import {UserContext} from '../../../context/User'
import {GroupDetailsContext} from '../../../context/Modal/GroupDetails'
import {AssignAuditContext} from '../../../context/Modal/AssignAudit'
import {RecurringDetailsContext} from '../../../context/Modal/RecurringDetails'
import {normalizeDate} from '../../../utils/normalizeData'
import {ToastMessageContext} from '../../../context/ToastMessage'
import {useModal} from '../../../common/Modal'

function AuditSteps({error, setError}) {
  const {t} = useTranslation()
  const paneState = useContext(AuditPaneContext)
  const modalBar = useContext(AuditModalBarContext)
  const toast = useContext(ToastMessageContext)
  const user = useContext(UserContext)
  const {getAll, addAudit, editAudit, selectAudit, searchParams} = useContext(AuditContext)
  const {resetFilterReloading} = useContext(AuditModalApiContext)
  const [loader, setLoader] = React.useState(false)

  const {editTemplate, getAllTemplates, templateParams, selectTemplate} = useContext(
    TemplatesContext
  )

  const {
    id,
    name,
    method,
    start_date,
    due_date,
    allow_scanning_after_due_date,
    due_soon_days,
    gps_location,
    asset_details,
    status,
    resetAuditDetails,
    signature,
  } = React.useContext(AuditDetailsContext)
  const {showRecurrence, resetRecurringDetails, acomplishedRecurrenceData} = React.useContext(
    RecurringDetailsContext
  )

  const {
    audit_entities_attributes,
    allow_auto_update_fields,
    allow_user_update_fields,
    allow_user_without_edit_permission,
    resetGroupsDetails,
  } = React.useContext(GroupDetailsContext)
  const {
    individual_audit,
    audit_users_attributes,
    audit_email_users_attributes,
    audit_user_templates_attributes,
    resetAssignDetails,
  } = React.useContext(AssignAuditContext)
  const {resetBarDetails} = useContext(AuditModalBarContext)
  const simpleModal = useModal('simple', {})

  const modalType = paneState.modalType
  const modalFor = paneState.modalFor
  const activeCreateForm = modalBar.activeCreateForm
  const totalCreateForms = 4

  const resetDetails = () => {
    paneState.closeModal()
    resetAuditDetails()
    resetGroupsDetails()
    resetAssignDetails()
    resetRecurringDetails()
    resetBarDetails()
    // resetEntities()
    // resetEntityDetails()
    resetFilterReloading()
  }

  const recurrenceData = () => {
    let recurrence_attributes = acomplishedRecurrenceData()
    if (modalFor === 'Template') {
      if (modalType === 'duplicate') {
        delete recurrence_attributes.id
      }
      return recurrence_attributes
    } else {
      return showRecurrence && recurrence_attributes
    }
  }
  const isInvalidName = name.includes('/')

  const auditData = () => {
    return {
      name,
      method,
      start_date: normalizeDate(start_date),
      due_date: due_date ? normalizeDate(due_date) : '31/12/2100',
      asset_details,
      gps_location,
      recurrence_attributes: recurrenceData(),
      individual_audit,
      allow_scanning_after_due_date,
      user_id: user.details.id,
      account_id: user.details.account_id,
      due_soon_days: due_date ? due_soon_days : 0,
      audit_entities_attributes,
      allow_user_without_edit_permission,
      allow_user_update_fields,
      allow_auto_update_fields,
      audit_users_attributes,
      audit_email_users_attributes,
      audit_user_templates_attributes,
      timezone: user.details.timezone,
      signature_required_to_close: signature,
    }
  }

  const tosterAlertPopup = response => {
    if (!!response && response.status !== 500) {
      if (
        response.data.errors &&
        response.data.errors[0].base &&
        response.data.errors[0].base[0] !== undefined
      ) {
        toast.popMessage(response.data.errors[0].base[0], 'error')
      } else {
        toast.popMessage('Internal Server Error', 'error')
      }
    } else {
      toast.popMessage('Internal Server Error', 'error')
    }
  }

  async function saveAuditInfo() {
    if (!loader) {
      let audit = auditData()
      try {
        setLoader(true)
        addAudit(audit).then(response => {
          if (response.id !== undefined) {
            toast.popMessage(`${response.name} is saved successfully`, 'success')
            resetDetails()
            if (showRecurrence) {
              getAllTemplates({start: 1, ...templateParams})
            }
            getAll({start: 1, ...searchParams})
          } else {
            tosterAlertPopup(response)
            setLoader(false)
          }
        })
      } catch (e) {
        console.log(`Create audit method failed ${e}`)
      }
    }
  }

  async function saveEditAuditInfo() {
    let audit = auditData()
    try {
      setLoader(true)
      editAudit(id, audit).then(response => {
        if (response?.id !== undefined) {
          toast.popMessage(`${response.name} is updated successfully`, 'success')
          resetDetails()
          if (paneState.isExpandOpen || paneState.isSidebarOpen) {
            selectAudit(response, false)
          }
        } else {
          tosterAlertPopup(response)
          setLoader(false)
        }
      })
    } catch (e) {
      console.log(`Create Audit failed: ${audit.name}`)
    }
  }

  async function saveEditTemplateInfo() {
    let audit = auditData()
    try {
      setLoader(true)
      editTemplate(id, audit).then(response => {
        if (response.id !== undefined) {
          toast.popMessage(`${response.name} is updated successfully`, 'success')
          resetDetails()
          if (paneState.isExpandOpen || paneState.isSidebarOpen) {
            selectTemplate(response, false)
          }
        } else {
          tosterAlertPopup(response)
          setLoader(false)
        }
      })
    } catch (e) {
      console.log(`Create Template failed: ${audit.name}`)
    }
  }

  const handleCheck = () => {
    if (activeCreateForm + 1 <= totalCreateForms && modalType !== 'edit' && modalFor === 'Audit') {
      saveAuditInfo()
    } else if (
      modalBar.activeCreateForm + 1 <= totalCreateForms &&
      modalFor !== 'Audit' &&
      modalType !== 'edit'
    ) {
      saveAuditInfo()
    } else if (modalBar.activeCreateForm + 1 <= totalCreateForms && modalFor !== 'Audit') {
      saveEditTemplateInfo()
    } else if (modalBar.activeCreateForm + 1 <= totalCreateForms && modalFor === 'Audit') {
      if (status === 'open') {
        if (modalBar.editWarning) {
          if (simpleModal) {
            simpleModal.show({
              scheme: 'warning',
              title: 'Apply changes?',
              description: t('audit.alert.desciption-edit'),
              buttons: {
                affirmative: {
                  label: t('audit.alert.confirm'),
                  click: (d, modal) => {
                    saveEditAuditInfo()
                    modal.hide()
                  },
                },
                negative: {
                  label: t('audit.alert.cancel'),
                  click: (d, modal) => {
                    resetDetails()
                    modal.hide()
                  },
                },
              },
            })
          }

          modalBar.setEditWarning(false)
        } else {
          saveEditAuditInfo()
        }
      } else {
        saveEditAuditInfo()
      }
    } else {
      saveEditAuditInfo()
    }
  }

  const stepId = isTemplate => {
    let stepId
    if (isTemplate) {
      if (activeCreateForm === 3) {
        stepId = loader ? 'save_tab--loading' : 'template_save_tab'
      } else {
        stepId = 'audit_template_edit_tab'
      }
    } else {
      if (modalType === 'New' || modalType === 'duplicate') {
        stepId = 'new_tab'
      } else if (activeCreateForm === 3) {
        stepId = loader ? 'save_tab--loading' : 'save_tab'
      } else {
        stepId = 'audit_template_edit_tab'
      }
    }
    return stepId
  }

  const stepClass = (step, className) => {
    let stepClass
    if (modalType !== 'New') {
      if (activeCreateForm === 3 && step === 3 && modalType === 'duplicate') {
        stepClass = loader ? 'active current_tab--loading' : 'active current_tab'
      } else {
        stepClass = 'active'
      }
    } else {
      if (activeCreateForm > step) {
        stepClass = 'active'
      } else {
        if (activeCreateForm === step) {
          stepClass = `${className ? ` ${className}` : 'current'}`
        } else {
          stepClass = 'Inactive'
        }
      }
    }
    return stepClass
  }

  const stepAction = (step, isTemplate) => {
    if (isTemplate) {
      if (step === 3 && activeCreateForm === 3) {
        if (modalType === 'edit') {
          if (simpleModal) {
            simpleModal.show({
              scheme: 'warning',
              title: 'Apply changes?',
              description: `${t('audit.alert.template-edit-desciption')}`,
              buttons: {
                affirmative: {
                  label: t('audit.alert.confirm'),
                  click: (d, modal) => {
                    handleCheck()
                    modal.hide()
                  },
                },
                negative: {
                  label: t('audit.alert.cancel'),
                  click: (d, modal) => {
                    resetDetails()
                    modal.hide()
                  },
                },
              },
            })
          }
        } else {
          handleCheck()
        }
      } else {
        modalBar.handleChangeCreateForm(step)
      }
    } else {
      step === 3 && activeCreateForm === 3 ? handleCheck() : modalBar.handleChangeCreateForm(step)
    }
  }

  const listItem = (step, label, isDisabled = false, isTemplate = false) => {
    const isStepThree = step === 3
    const isActive = modalBar.activeCreateForm === step

    return (
      <li
        onClick={
          !isDisabled
            ? () => {
                if (name.includes('/')) {
                  setError(
                    'Special character forward slash (/) is not allowed. Please remove to proceed.'
                  )
                } else {
                  setError('')
                  stepAction(step, isTemplate)
                }
              }
            : () => {
                setError(
                  'Special character forward slash (/) is not allowed. Please remove to proceed.'
                )
              }
        }
        className={`${stepClass(step, isTemplate ? 'template-step' : 'audit-step')} ${
          isStepThree ? 'custom-label' : ''
        } ${isActive ? 'active-step' : ''}`}
        data-label={isStepThree ? t(`audit.audit-modal.${label}`) : ''}
      >
        {!isStepThree && label ? t(`audit.audit-modal.${label}`) : ''}
      </li>
    )
  }

  return (
    <div className="container">
      <ul className="progressbar">
        {listItem(0, 'audit-details', isInvalidName)}
        {listItem(1, 'group-details', isInvalidName)}
        {listItem(2, 'assign-audit', isInvalidName)}
        {listItem(
          3,
          modalBar.activeCreateForm === 3
            ? modalType === 'New' || modalType === 'duplicate'
              ? 'create-audit'
              : 'save-audit'
            : 'audit-summary',
          isInvalidName
        )}
      </ul>
    </div>
  )
}

export default AuditSteps
